import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 0,
  class: "mb-20 fullWidth"
}
const _hoisted_4 = {
  key: 0,
  style: {"display":"flex","flex-flow":"column"}
}
const _hoisted_5 = {
  key: 1,
  class: "dialog-footer mt-20"
}
const _hoisted_6 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MiniBusinessList = _resolveComponent("MiniBusinessList")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_BusinessList = _resolveComponent("BusinessList")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20",
      disabled: _ctx.formDisabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "所属公司",
            prop: "titleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.titleId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.titleId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                disabled: Boolean(_ctx.selectcCustomerTitleId) || _ctx.itemDisabled,
                "remote-method": _ctx.getTitleOptionRemote,
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTitleOptionRemote(''))),
                onChange: _ctx.handleCompanyTitleChange
              }, {
                default: _withCtx(() => [
                  (_ctx.titleOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.titleOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "remote-method", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "税率",
            prop: "rate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.rate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.rate) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                disabled: Boolean(_ctx.selectcCustomerTitleId) || _ctx.itemDisabled
              }, {
                default: _withCtx(() => [
                  (_ctx.taxRateList.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.taxRateList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item + '%',
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "客户公司名称",
            prop: "customerCompanyId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.customerCompanyId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                disabled: _ctx.itemDisabled,
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.companyRemoteMethod(''))),
                "remote-method": query => _ctx.companyRemoteMethod(query),
                onChange: _ctx.handleCompanyChange
              }, {
                default: _withCtx(() => [
                  (_ctx.companyOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companyOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id,
                          disabled: item.disable
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "remote-method", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "购买方抬头",
            prop: "customerCompanyTicketTitleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyTicketTitleId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.customerCompanyTicketTitleId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                onChange: _ctx.handleCustomerCompanyTicketTitleChange
              }, {
                default: _withCtx(() => [
                  (_ctx.customerCompanyTicketOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.customerCompanyTicketOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.titleName,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "发票名称",
            prop: "titleName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.titleName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.titleName) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "税号",
            prop: "taxId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.taxId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.taxId) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "开户银行",
            prop: "bank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.bank,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.bank) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "银行账号",
            prop: "account"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.account,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.account) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "注册地址",
            prop: "registeredAddress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.registeredAddress,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.registeredAddress) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "电话号码 ",
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.phone,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.phone) = $event)),
                type: "input",
                class: "filter-item",
                disabled: _ctx.itemDisabled || !_ctx.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "是否提交 ",
            prop: "submit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.ruleForm.submit,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.submit) = $event)),
                label: "是否提交",
                size: "large"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: "fullWidth"
          }, {
            label: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode(" 备注 ", -1),
              _createElementVNode("span", { style: {"color":"red"} }, "（如需拆分为多张发票，请在备注栏填写）", -1)
            ]))]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                style: {"width":"100%"},
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.canSubmit && _ctx.mode !== 'approval')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleAddBusinessComand,
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode(" 添加业务 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.removeBusiness }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" 移除业务 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_MiniBusinessList, {
            businessList: _ctx.ruleForm.details,
            onTableSelect: _ctx.handleTableSelect
          }, {
            before: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55",
                fixed: "left"
              }),
              _createVNode(_component_el_table_column, {
                prop: "no",
                label: "业务编号",
                width: "150",
                "show-overflow-tooltip": ""
              })
            ]),
            after: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "业务名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "brand",
                label: "业务品牌"
              }),
              _createVNode(_component_el_table_column, {
                prop: "model",
                label: "型号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "serial",
                label: "序列号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "数量",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "orderNo",
                label: "订单号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "customerOrderNo",
                label: "客户订单号"
              })
            ]),
            _: 1
          }, 8, ["businessList", "onTableSelect"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    (_ctx.mode === 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[24] || (_cache[24] = _createElementVNode("span", { style: {"margin-bottom":"10px"} }, "申请理由", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.applyCancelReason,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.applyCancelReason) = $event)),
            type: "textarea",
            style: {"width":"80%"},
            class: "filter-item",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.canSubmit)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                loading: _ctx.submitLoading,
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('table.confirm')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "业务列表",
          width: "80%",
          "destroy-on-close": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_el_button, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.addBusiness
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BusinessList, {
              mode: "table",
              ref: "BusinessList",
              customerCompanyId: _ctx.ruleForm.customerCompanyId,
              excludeIds: _ctx.excludeIds,
              pageType: "INVOICE",
              titleId: _ctx.ruleForm.titleId,
              orderTaxRate: _ctx.ruleForm.rate
            }, null, 8, ["customerCompanyId", "excludeIds", "titleId", "orderTaxRate"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}